import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[locale]/(client)/services/events/caseStudy/page.jsx");
